// extracted by mini-css-extract-plugin
export default {"recos":"S2-z","productCardOverride":"T2-z","rowHasBadge":"U2-z"};